export default __webpack_public_path__ + "search-examples-uitextfield-search-960-cc69801f1919a9002e3a82b447f8c5f9.webp";